import { defineComponent as _defineComponent } from 'vue'
import UiButton from 'JS/components/UiButton.vue';
import { BannerWidgetResource } from 'JS/dxp/types/widgets/banner-widget';
import { computed } from 'vue';
import { createPromoDataAttributes } from 'JS/utilities/analytics';
import { normalizeTrailingSlash } from 'JS/utilities/url';
import { useDxpColors } from 'JS/dxp/composables/colors';


export default /*#__PURE__*/_defineComponent({
  __name: 'BannerWidget',
  props: {
    widget: null
  },
  setup(__props: any) {

const props = __props as {
	widget: BannerWidgetResource
}



const { backgroundColor, textColor, uiButtonColor } = useDxpColors(() => props.widget.widget.backgroundColor);

const gaDataAttributes = computed(() => createPromoDataAttributes({
	promoId: normalizedLink.value.replace("https://www.farmandfleet.com", ""),
	creativeSlot: "dxp_banner_1",
	creativeName: `dxp_banner_${props.widget.widget.layout}`,
	promoName: `${props.widget.widget.heading}. ${props.widget.widget.subheading}`
}));

const normalizedLink = computed(() => {
	return normalizeTrailingSlash(props.widget.widget.buttonUrl);
});


return { __sfc: true,props, backgroundColor, textColor, uiButtonColor, gaDataAttributes, normalizedLink, UiButton }
}

})